var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.1034 16.6589L13.7262 12.2404C14.8516 10.9419 15.4683 9.30816 15.4683 7.60732C15.4683 3.63348 12.1371 0.400391 8.04274 0.400391C3.94835 0.400391 0.617188 3.63348 0.617188 7.60732C0.617188 11.5812 3.94835 14.8143 8.04274 14.8143C9.57983 14.8143 11.0446 14.3643 12.2969 13.5101L16.7074 17.9621C16.8917 18.1479 17.1397 18.2504 17.4054 18.2504C17.6569 18.2504 17.8955 18.1573 18.0766 17.9881C18.4614 17.6287 18.4737 17.0327 18.1034 16.6589ZM8.04274 2.28046C11.0691 2.28046 13.5312 4.67003 13.5312 7.60732C13.5312 10.5446 11.0691 12.9342 8.04274 12.9342C5.01634 12.9342 2.55429 10.5446 2.55429 7.60732C2.55429 4.67003 5.01634 2.28046 8.04274 2.28046Z",
    fill: "#4A4A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b6c818bd.svg";
export { ForwardRef as ReactComponent };